import { Form, Button } from "@core/components/ui";
import { FormInput } from "@core/components/form/FormInput";
import { useNcfzLoginForm } from "@features/auth/hooks/form/useNcfzLoginForm";
import { cn } from "@core/utils/domUtil";

export default function NcfzLogin() {
  const { handleSubmit, isPending, ...form } = useNcfzLoginForm();

  return (
    <Form {...form}>
      <form onSubmit={handleSubmit} className="flex w-full flex-col gap-[10px]">
        <FormInput name="secondaryId" placeholder="아이디" control={form.control} />
        <FormInput type="password" name="secondaryPassword" placeholder="비밀번호" control={form.control} />
        <Button type="submit" variant="bgPoint600" size="large" disabled={isPending} className={cn("w-full")}>
          로그인
        </Button>
      </form>
    </Form>
  );
}
